import API from "apiInstance";
import { toast } from "react-toastify";

export const donorSignup = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/donor/signup",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donorLogin = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/donor/login",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const adminLogin = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/user/login",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getDonor = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/donor/",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donorGetResetToken = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/donor/sendEmail-reset-token",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donorResetPassword = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/donor/reset-password",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getTokenDetails = async ({ tokenId }) => {
  try {
    const response = await API({
      method: "get",
      url: `/api/donor/token-details/${tokenId}`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donorDeleteAccount = async () => {
  try {
    const response = await API({
      method: "delete",
      url: `/api/donor/delete-account`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const ngoLogin = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/ngo/login",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getNgo = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/ngo/",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const ngoChangePassword = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/ngo/change-password",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donorChangePassword = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/donor/update-password",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const getNgoProfile = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/ngo/profile",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const createNgoProfile = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/ngo/create-profile",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const NgoApply = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/ngo/apply",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const waitlistJoin = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/news-letter",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
